module.exports = __webpack_public_path__ + "media/images/flags/16/Mars-e76db9d7d9f6e8db9d105405176481db.png";